<script lang="ts">
  import { domId } from "../../../lib/dom";
  import { type Component } from "svelte";
  import Info from "~icons/ph/info";
  import HowToIdentifyFinanceCompany from "../../HowToIdentifyFinanceCompany.svelte";

  let {
    answer,
    back,
    inactive,
    financeCompany,
    financeCompanyOptions,
    nextStep,
  }: {
    answer: ({ nextStep }) => void;
    back: () => void;
    inactive: boolean;
    financeCompany: string;
    financeCompanyOptions: string[];
    nextStep: Component;
  } = $props();

  let financeCompanyInput = $state("");
  let error = $state(null);

  function handleContinue() {
    confirmNameInput();
    if (!error) {
      answer({nextStep});
    }
  }

  function confirmNameInput() {
    error = null;
    if (financeCompanyInput === "") {
      error = "Finance company name is required";
    }
    if (financeCompanyInput === financeCompany) {
      error = "Please enter a different finance company name from the original one you provided";
    }
  }

  const financeCompanyId = domId("finance-company");
  const financeCompanyOptionsId = domId("finance-company-options");
</script>

<div class="h-full">
  <fieldset class="ui-fieldset">
    <legend>>What was the name of the finance company?</legend>
    <input
      id={financeCompanyId}
      type="text"
      list={financeCompanyOptionsId}
      name="finance_company[name]"
      class="ui-input"
      bind:value={financeCompanyInput}
    />

    <div class="ui-alert ui-alert-info">
      <Info />
      <p>Type to search or to enter a new name</p>
    </div>

    <div><b>Previous answer</b>: {financeCompany}</div>
    {#if error}<div class="ui-error">{error}</div>{/if}
  </fieldset>

  <div class="divider"></div>
  <HowToIdentifyFinanceCompany />
</div>

<datalist id={financeCompanyOptionsId}>
  {#each financeCompanyOptions as financeCompanyOption}
    <option value={financeCompanyOption}></option>
  {/each}
</datalist>

<div class="floating-footer">
  <button type="button" class="btn btn-ghost" onclick={back}>Back</button>
  <button type="submit" class="btn btn-primary" onclick={handleContinue} disabled={inactive}>Continue</button>
</div>
